import React from 'react';
import { ButtonGroup } from 'components/ui';
import { useError } from 'contexts/error';
import { useQuery } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { DividerContainer } from 'components/styles_components/container';
import DashboardQuery from 'queries/user/dashboard';
import Loader from 'components/loader';
import Welcome from 'components/dashboard/welcome';
import Container from 'components/layout/container';
import CreatInspectionButton from 'components/inspection/button/create';
import Inspections from 'components/dashboard/inspections';
import MonthlyOverview from 'components/dashboard/monthly_overview';
import DailyOverview from 'components/dashboard/daily_overview';

const Index = () => {
  const setError = useError();

  const {
    data = { space: {}, inspections: {}, places: {}, inspectionSubjects: {} },
    loading,
    error,
  } = useQuery(DashboardQuery, {
    onError: () => {
      setError('error.user.dashboard');
    },
  });

  if (loading || error) {
    return <Loader />;
  }

  return (
    <Container>
      <Welcome user={data.user}>
        <ButtonGroup>
          <CreatInspectionButton
            label={<FormattedMessage id="button.add.inspection" />}
            disabled={data.space.overInspectionsLimit || !data.space.adminRole}
          />
        </ButtonGroup>
      </Welcome>
      <Inspections userData={data.user} spaceData={data.space} />
      <DividerContainer />
      <MonthlyOverview />
      <DividerContainer />
      <DailyOverview />
    </Container>
  );
};

export default Index;
